import { useRef, useCallback } from "react";
import '../styles/Header.css';
import '../styles/CursorCircle.css';

const Header = () => {
    const toggleRef = useRef(null);

    const closeMenu = useCallback(() => {
        if (toggleRef.current) toggleRef.current.checked = false;
    }, []);

    return (
        <header className="header">
        <nav>
            <div className='github'>
                <a href="https://github.com/1-JaeYo"><i className="fa-brands fa-github" id='git1'></i></a>
            </div>

            <input type="checkbox" id="nav-toggle" aria-label="Toggle navigation" ref={toggleRef}/>
            <label className="hamburger" htmlFor="nav-toggle">
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </label>

            <div className="nav-links">
                <a href="#about"  onClick={closeMenu}>
                <i className="fa-solid fa-face-smile"></i> about
                    <svg className="nav-border" viewBox="0 0 100 100" preserveAspectRatio="none">
                        <rect
                            x="0"
                            y="0"
                            width="100"
                            height="100"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="10"
                            strokeDasharray="400"
                            strokeDashoffset="400"
                        />
                    </svg>
                </a>
                <a href="#skills"  onClick={closeMenu}>
                <i className="fa-solid fa-code"></i> skills
                    <svg className="nav-border" viewBox="0 0 100 100" preserveAspectRatio="none">
                        <rect
                            x="0"
                            y="0"
                            width="100"
                            height="100"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="10"
                            strokeDasharray="400"
                            strokeDashoffset="400"
                        />
                    </svg>
                </a>
                <a href="#projects"  onClick={closeMenu}>
                    <i className="fa-solid fa-diagram-project"></i> projects
                    <svg className="nav-border" viewBox="0 0 100 100" preserveAspectRatio="none">
                        <rect
                            x="0"
                            y="0"
                            width="100"
                            height="100"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="10"
                            strokeDasharray="400"
                            strokeDashoffset="400"
                        />
                    </svg>
                </a>
                <a href="#contact"  onClick={closeMenu}>
                    <i className="fa-solid fa-address-book"></i> contact
                    <svg className="nav-border" viewBox="0 0 100 100" preserveAspectRatio="none">
                        <rect
                            x="0"
                            y="0"
                            width="100"
                            height="100"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="10"
                            strokeDasharray="400"
                            strokeDashoffset="400"
                        />
                    </svg>
                </a>
            </div>
            <div className='theme'>
                {/* <button onClick={toggleTheme} className="theme-button">
                    {theme === 'light' ? 'Dark Mode' : 'Light Mode'}
                </button> */}
                <a href="https://www.linkedin.com/in/jonathan-okonkwo/"><i className="fa-brands fa-linkedin" id='git1'></i></a>
            </div>
        </nav>
        </header>
    );
};

export default Header;
